import React from 'react';
import Title from '../../../components/AccountSettings/Title';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from '../../../views/admin/EditableTable/types';
import FormikDropdown from '../../../components/formik-dropdown';

interface Props {
  universityId: string;
}

const ReportDropdown = () => {
  const options = reportTypeInfo.map(({name}) => ({value: name, text: name}));

  return <FormikDropdown name="scheduledReportFileName" options={options} />;
};

const columns: ColumnSettings[] = [
  {
    name: 'scheduledReportFileName',
    title: 'Scheduled Report File Name',
    editable: true,
    sortable: true,
    FormField: ReportDropdown,
  },
  {
    name: 'customFileName',
    title: 'Custom File Name',
    editable: true,
    sortable: true,
  },
];

const reportTypeInfo = [
  {
    name: 'Current Followers HS',
    description: 'HS student reports of all current followers',
  },
  {
    name: 'Current Followers HS - New Followers',
    description: 'HS student reports of only new followers',
  },
  {
    name: 'Current Followers CC',
    description: 'Transfer student reports of all current followers',
  },
  {
    name: 'Current Followers CC - New Followers',
    description: 'Transfer student reports of only new followers',
  },
  {
    name: 'Non Followers HS',
    description: 'HS student reports of all non-followers',
  },
  {
    name: 'Non Followers CC',
    description: 'Transfer student reports of all non-followers',
  },
];

const ScheduledReportFileNameMappings = ({universityId}: Props) => (
  <div className="account-settings-form" data-testid="scheduled-report-file-name-mappings">
    <Title>Scheduled Report File Name Mappings</Title>
    <div
      style={{
        marginBottom: '16px',
        padding: '12px',
        backgroundColor: '#f5f5f5',
        borderRadius: '4px',
      }}
    >
      <strong>Available Report Types:</strong>
      <ul style={{marginTop: '8px', marginBottom: 0}}>
        {reportTypeInfo.map(({name, description}) => (
          <li key={name}>
            <strong>{name}</strong> - {description}
          </li>
        ))}
      </ul>
    </div>
    <EditableTable
      basePath={`/v1/admin/scheduled-report-file-name-mappings?university_id=${universityId}`}
      defaultSortKey="scheduledReportFileName"
      columns={columns}
      identifier="scheduled-report-file-name-mappings"
      defaultValues={{universityId: universityId}}
    />
  </div>
);

export default ScheduledReportFileNameMappings;
